import React from 'react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ClockIcon } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function Pricing() {
  return <section id="pricing" className="py-20 px-4 bg-dark-DEFAULT" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <div className="text-center mb-12" data-id="element-180">
          <h2 className="text-5xl md:text-6xl font-bebas text-white mb-4" data-id="element-181">
            Elige tu MegaPack Voley Listo
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-182">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <PricingSelector data-id="element-183" />

        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-184">
          <p className="text-sm text-text-secondary mb-6" data-id="element-185">
            💱 Pagarás en la moneda de tu país. El precio base es en USD y se
            convierte automáticamente al momento del pago.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-xs text-text-secondary" data-id="element-186">
            <span className="flex items-center" data-id="element-187">
              <LockIcon size={14} className="mr-1" data-id="element-188" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-189">
              <ClockIcon size={14} className="mr-1" data-id="element-190" /> Acceso en 5 min
            </span>
            <span className="flex items-center" data-id="element-191">
              <ShieldCheckIcon size={14} className="mr-1" data-id="element-192" /> Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-193">
              <CreditCardIcon size={14} className="mr-1" data-id="element-194" /> Tarjeta · PayPal ·
              Transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
}